/*
  eslint no-underscore-dangle: ["error", { "allow":
    ["_northEast", "_northWest", "_southEast", "_southWest", "_icon", "_element"]
  }]
*/
/* eslint camelcase: ["error", {allow: ["bb_ne", "bb_nw", "bb_se", "bb_sw"]}] */
/* global smily, bootstrap, L */

class RentalsMap extends HTMLElement {
  constructor() {
    super();

    this.googleMapKey = smily.website.googleMapKey;

    if (this.googleMapKey) {
      this.googleMapScript = this.loadGoogleMapScript();
    }

    this.markerTpl = document.getElementById('rentalsSearchMarker');
    this.isFullscreen = undefined;
    this.initialParent = this.parentElement;

    const btnToggleFullscreen = document.querySelectorAll('.rentalsMap-fullscreenToggler');
    const init = () => {
      if (this.isMobile || this.hasAttribute('data-fullscreen-enabled')) {
        if (this.isFullscreen !== true) {
          this.modalContent.insertAdjacentElement('afterbegin', this);
          this.isFullscreen = true;
        }
      } else if (this.isFullscreen !== false) {
        this.bsModal.hide();
        this.initialParent.insertAdjacentElement('afterbegin', this);
        this.isFullscreen = false;
      }
    };

    document.addEventListener('DOMContentLoaded', () => {
      // Remove spinner
      this.innerHTML = '';
      this.initMap();
      this.initToggleFocus();

      if (btnToggleFullscreen.length) {
        this.initFullscreenMap(btnToggleFullscreen);
        init();
        window.addEventListener('resize', () => {
          init();
        });
      }
    });
  }

  get rentals() {
    return document.querySelectorAll('[data-rentals-map-marker]');
  }

  get for() {
    return document.querySelector(this.getAttribute('for'));
  }

  get isMobile() {
    return smily.mediaBreakPoint.down('lg');
  }

  initMap() {
    if (this.googleMapKey) {
      this.googleMapScript
        .catch((error) => {
          this.googleMapKey = false;
          // eslint-disable-next-line no-console
          console.error(error);
        })
        .then(() => this.initLeaflet());
    } else {
      this.initLeaflet();
    }
  }

  initFullscreenMap(btnToggleFullscreen) {
    const btnCloseFullscreen = document.getElementById('rentalsMapCloser');

    // Move map to modal for mobile devices
    const modalId = 'rentalsMapModal';
    const modalTemplate = smily.templates.modal({
      modalClass: '',
      id: modalId,
      dialogClass: 'modal-fullscreen',
      bodyClass: 'p-0',
      contentClass: 'h-100',
    });

    document.body.insertAdjacentHTML('beforeend', modalTemplate);
    const modal = document.getElementById(modalId);
    this.modalContent = modal.querySelector('[data-content]');
    const bsModal = new bootstrap.Modal(modal, { backdrop: false });
    this.bsModal = bsModal;

    modal.querySelector('.modal-header').classList.add('d-none');
    this.modalContent.appendChild(btnCloseFullscreen.parentElement);
    btnCloseFullscreen.parentElement.classList.remove('d-none');

    if (this.for) {
      // const { height } = getComputedStyle(this.for);
      // modal.style.height = `calc(100% - ${height})`;
      // modal.style.top = `${height}`;
    }

    const toggleSVG = (btn, active) => {
      const svgs = btn.querySelectorAll('svg');

      if (svgs.length !== 2) return;

      svgs[0].classList.toggle('d-none', active);
      svgs[1].classList.toggle('d-none', !active);
    };

    const hideModal = (btn) => {
      toggleSVG(btn, false);

      modal.addEventListener('hidden.bs.modal', () => {
        if (this.for) {
          this.for.style.zIndex = '';
        }
      }, { once: true });

      bsModal.hide();
    };

    [...btnToggleFullscreen].forEach((btn) => {
      btn.addEventListener('click', () => {
        if (bsModal._element.classList.contains('show')) {
          hideModal(btn);
          return;
        }

        // Little trick to fit map to modal container
        bsModal.show();
        this.map.invalidateSize(false);
        this.setBounds();
        bsModal.hide();
        modal.classList.add('fade');

        bsModal.show();

        if (this.for) {
          this.scrollToOffset();
          this.for.style.zIndex = 1200;
        }

        toggleSVG(btn, true);
      });
    });

    btnCloseFullscreen.addEventListener('click', () => hideModal(btnCloseFullscreen));
  }

  initToggleFocus() {
    const focusBtn = document.getElementById('rentalsMapFocus');
    const resultsCol = document.querySelector('[data-rentals-map-unfocus]');
    const mapCol = document.querySelector('[data-rentals-map-focus]');

    if (!focusBtn && !resultsCol && !mapCol) return;

    let interval;

    // Refresh map size until transition ended
    mapCol.ontransitionstart = () => {
      const transitionFPS = 1000 / 100;
      interval = setInterval(() => {
        this.map.invalidateSize(false);
      }, transitionFPS);
    };

    mapCol.ontransitionend = () => {
      clearInterval(interval);
    };

    // Toggle map full width
    focusBtn.addEventListener('click', () => {
      if (this.mapFocused) {
        mapCol.style.width = '';
        mapCol.style.transform = '';
        resultsCol.style.transform = '';
        focusBtn.classList.remove('active');

        this.map.invalidateSize(true);
        this.mapFocused = false;
      } else {
        const { width } = getComputedStyle(mapCol);

        resultsCol.style.transform = 'translateX(-100%)';
        mapCol.style.width = '100vw';
        mapCol.style.transform = `translateX(calc(-100% + ${width}))`;
        focusBtn.classList.add('active');

        this.mapFocused = true;
      }
    });
  }

  initLeaflet() {
    let layer;

    this.map = L.map(this);
    this.map.setMaxBounds([[-90, -180], [90, 180]]);
    this.map.setMinZoom(3);
    this.map.zoomControl.setPosition('topright');
    this.mapMarkers = L.layerGroup().addTo(this.map);
    this.setBounds();
    this.addMarkers();

    if (!this.hasAttribute('data-scroll-enabled')) {
      this.map.scrollWheelZoom.disable();
    }

    if (this.googleMapKey) {
      // Possible options: SATELLITE, ROADMAP, HYBRID, TERRAIN
      layer = new L.Google(this.dataset.layerType || smily.website?.googleMapType || 'ROADMAP', this.googleMapOptions());
    } else {
      layer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
    }

    this.map.addLayer(layer);
    this.initUnavailableMarkers();
    this.initForm();
    this.dispatchEvent(new Event('rentals-map:leaflet:init'));
  }

  reset(options = { setBounds: true }) {
    this.mapMarkers.clearLayers();
    if (options.setBounds) {
      this.setBounds();
    }
    this.addMarkers();
  }

  setBounds() {
    const url = new URL(document.location);
    const { bb_ne, bb_sw } = Object.fromEntries([...url.searchParams]);

    this.disableMapMoveEvents = true;
    this.map.once('moveend', () => { this.disableMapMoveEvents = false; });

    if (bb_ne && bb_sw) {
      this.map.fitBounds(
        [
          bb_ne.split(','),
          bb_sw.split(','),
        ],
      );
    } else if (this.rentals.length === 0) {
      // do nothing
    } else if (this.rentals.length === 1) {
      const rental = this.rentals[0];
      const zoom = this.dataset.mapZoom || 11;

      this.map.setView([this.rentalLat(rental), this.rentalLng(rental)], zoom);
    } else {
      const bounds = L.latLngBounds([...this.rentals].map((rental) => [
        rental.dataset.lat,
        rental.dataset.lng,
      ]));

      const { _northEast, _southWest } = bounds;

      // Check if the coordinates are identical
      if (_northEast.equals(_southWest)) {
        const defaultLatLng = L.latLng(_northEast);
        this.map.setView(defaultLatLng, 12);
      } else {
        const opts = { padding: [50, 50] };
        // eslint-disable-next-line no-underscore-dangle
        const { center, zoom } = this.map._getBoundsCenterZoom(bounds, opts);
        // Fix leaflet returning Infinity zoom when bounds are too small which throw an error
        this.map.setView(center, zoom === Infinity ? 18 : zoom, opts);
      }
    }
  }

  rentalLat(rental) {
    return rental.dataset.lat;
  }

  rentalLng(rental) {
    return rental.dataset.lng;
  }

  addMarkers() {
    this.rentals.forEach((rental, index) => this.addMarker(rental, index));
    this.addRentalsEvents();
    this.rentalsIds = [...this.rentals].map((rental) => rental.dataset.rentalId);
  }

  addMarker(rental, index) {
    let markerClasses = `${rental.id}-marker`;

    if (rental.dataset.unavailable === '1') {
      markerClasses += ' marker-unavailable hide';
    }

    const marker = L.marker(
      [
        this.rentalLat(rental),
        this.rentalLng(rental),
      ],
      {
        icon: L.dataDivIcon({
          html: this.markerHtml(rental),
          className: markerClasses,
          data: {
            rentalTarget: `#${rental.id}`,
          },
        }),
      },
    );

    this.addMarkerEvents(marker);

    const icon = marker.addTo(this.mapMarkers)._icon;
    const label = icon.firstElementChild;

    this.toggleLabelClasses(label, false);
    icon.style.zIndex = 500 + index;
    icon.dataset.previousZindex = icon.style.zIndex;

    // Animate new markers
    if (!this.rentalsIds?.includes(rental.dataset.rentalId)) {
      setTimeout(() => {
        label.classList.remove('opacity-0');
      }, index * 40);
    } else {
      label.classList.remove('opacity-0');
    }

    // Prevent zoom in
    this.disableLeafletDbClick(icon);
  }

  markerHtml(rental) {
    const price = smily.formatPrice(rental.dataset.price);
    return this.markerTpl.innerHTML.replaceAll('%{price}', price);
  }

  addMarkerEvents(marker) {
    marker.addEventListener('mouseover', this.onMouseEvents.bind(this));
    marker.addEventListener('mouseout', this.onMouseEvents.bind(this));

    if (this.hasAttribute('data-marker-popover-enabled')) {
      marker.addEventListener('click', this.toggleMarkerPopover.bind(this));
    }
  }

  onMouseEvents(event) {
    const { type } = event;
    const icon = event.target._icon;
    const label = icon.firstElementChild;
    const active = type === 'mouseover';

    if (icon.dataset.popoverOpen) return;

    this.raiseMarkerIndex(icon, active);
    this.toggleLabelClasses(label, active);
  }

  toggleMarkerPopover(event) {
    const icon = event.target._icon;
    const label = icon.firstElementChild;
    const rental = document.querySelector(icon.dataset.rentalTarget);

    if (icon.dataset.popoverOpen) return;

    icon.dataset.popoverOpen = true;
    icon.classList.add('zindex-popover');

    const template = `
      <div class="popover overflow-hidden" role="tooltip">
        <div class="popover-body p-0"></div>
      </div>
    `;

    const content = rental.cloneNode(true);
    content.removeAttribute('id');

    icon.bsPopover = new bootstrap.Popover(label, {
      template,
      trigger: 'manual',
      boundary: this,
      container: label,
      html: true,
      content,
      placement: 'top',
    });

    const onClick = (evt) => {
      if (evt.target.closest(`#${icon.bsPopover.tip.id}`)) return;

      delete icon.dataset.popoverOpen;
      icon.classList.remove('zindex-popover');
      this.raiseMarkerIndex(icon, false);
      this.toggleLabelClasses(label, false);
      document.body.removeEventListener('click', onClick);
      icon.bsPopover.dispose();
    };

    icon.addEventListener('shown.bs.popover', () => {
      document.body.addEventListener('click', onClick);
    }, { once: true });

    icon.bsPopover.show();
  }

  toggleLabelClasses(label, active) {
    label.classList.toggle(label.dataset.bgHover, active);
    label.classList.toggle(label.dataset.colorHover, active);
    label.classList.toggle(label.dataset.bg, !active);
    label.classList.toggle(label.dataset.color, !active);
  }

  addRentalsEvents() {
    const handleHoverEvent = (event) => {
      const { type, target } = event;
      const marker = document.querySelector(`.${target.id}-marker`);
      const label = marker.children[0];
      const active = type === 'mouseenter';
      this.toggleLabelClasses(label, active);
      marker.classList.toggle('highlight', active);
      this.raiseMarkerIndex(marker, active);
    };

    this.rentals.forEach((rental) => rental.addEventListener('mouseenter', handleHoverEvent));
    this.rentals.forEach((rental) => rental.addEventListener('mouseleave', handleHoverEvent));
  }

  raiseMarkerIndex(marker, active) {
    // eslint-disable-next-line no-param-reassign
    marker.style.zIndex = active ? 1000 : marker.dataset.previousZindex;
  }

  initUnavailableMarkers() {
    document.querySelectorAll('#rentals_unavailable_link a').forEach((element) => {
      element.addEventListener(
        'toggled.bookingsync.show',
        () => document.querySelector('.marker-unavailable').classList.toggle('hide'),
      );
    });
  }

  initForm() {
    if (!this.for) return;

    let searchEnabled = this.hasAttribute('data-search-enabled');

    const savedSetting = window.localStorage.getItem('rentalsMapSearchEnabled');

    if (savedSetting) {
      searchEnabled = JSON.parse(savedSetting);
    }

    const html = `
      <div id="rentalsSearchByMap" class="leaflet-top leaflet-right d-flex px-5 w-100">
        <div class="leaflet-bar leaflet-control mx-auto bg-white p-2">
          <div class="rentals-map-form-group">
            <input id="RentalsMapForm" class="form-check-input" type="checkbox" ${searchEnabled ? 'checked' : ''}>
            <label for="RentalsMapForm" class="form-check-label stretched-link">
              <span class="ms-1">${smily.website.t.enableMapSearch}</span>
            </label>
          </div>
          <div class="rentals-map-form-status hstack gap-2 d-none">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ${smily.website.t.loadingMapSearch}
          </div>
        </div>
      </div>
    `;

    this.leafletControls = this.querySelector('.leaflet-control-container');
    this.leafletControls.insertAdjacentHTML('beforeend', html);
    this.formGroup = this.leafletControls.querySelector('.rentals-map-form-group');
    this.formStatus = this.leafletControls.querySelector('.rentals-map-form-status');
    this.formCheckbox = this.leafletControls.querySelector('#RentalsMapForm');

    // Save setting
    this.formCheckbox.addEventListener('change', () => {
      window.localStorage.setItem('rentalsMapSearchEnabled', this.formCheckbox.checked);
    });

    // prevent from zoom in
    this.disableLeafletDbClick(this.formGroup);

    const onMoveHandler = this.onMove.bind(this);
    this.map.addEventListener('dragstart', onMoveHandler);
    this.map.addEventListener('zoomstart', onMoveHandler);

    // Request loaded event
    this.for.addEventListener('update', () => {
      this.reset();
      this.toggleFormGroup(true);

      // rescroll after history.replaceState
      if (this.bsModal._element.classList.contains('show')) this.scrollToOffset();
    });
  }

  onMove() {
    if (this.disableMapMoveEvents) return;

    if (this.onMoveTimeout) {
      clearTimeout(this.onMoveTimeout);
    }

    const delay = 400;

    this.map.off('moveend');
    this.map.once('moveend', () => {
      if (this.formCheckbox.checked) {
        this.onMoveTimeout = setTimeout(() => {
          this.toggleFormGroup(false);
          this.submitForm();
        }, delay);
      }
    });
  }

  toggleFormGroup(active) {
    this.formGroup.classList.toggle('d-none', !active);
    this.formStatus.classList.toggle('d-none', active);
  }

  submitForm() {
    const bounds = this.map.getBounds();
    const mapBounds = {
      bb_ne: `${bounds._northEast.lat},${bounds._northEast.lng}`,
      bb_sw: `${bounds._southWest.lat},${bounds._southWest.lng}`,
    };

    // eslint-disable-next-line camelcase
    smily.trackers.ga('event', 'search_by_map', { event_category: 'search', event_label: 'search by map' });
    smily.trackers.fbq('track', 'search by map');

    return this.for.submit(mapBounds);
  }

  scrollToOffset() {
    let { offsetTop } = document.querySelector('[role="main"]');
    const rentalsSearchHero = document.querySelector('.rentals-search-hero');

    if (rentalsSearchHero) {
      offsetTop += rentalsSearchHero.offsetHeight;
    }

    // Temporarily override any CSS smooth scrolling
    const originalScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';

    window.scrollTo(0, offsetTop);

    // Restore the original scroll behavior
    document.documentElement.style.scrollBehavior = originalScrollBehavior;
  }

  loadGoogleMapScript() {
    return new Promise((resolve, reject) => {
      try {
        const el = document.createElement('script');
        const container = document.head || document.body;

        el.type = 'text/javascript';
        el.async = true;
        el.src = `//maps.googleapis.com/maps/api/js?key=${this.googleMapKey}`;

        el.addEventListener('load', () => {
          resolve({ status: true });
        });

        el.addEventListener('error', () => {
          reject(new Error('Failed to load the Google Map script'));
        });

        container.appendChild(el);
      } catch (err) {
        reject(err);
      }
    });
  }

  disableLeafletDbClick(element) {
    element.parentNode.querySelectorAll('*').forEach((el) => {
      el.addEventListener('dblclick', L.DomEvent.stopPropagation);
      L.DomEvent.on(el, 'pointerdown', L.DomEvent.stopPropagation);
    });
  }

  googleMapOptions() {
    if (smily.website.googleMapOptions) {
      return {
        mapOptions: smily.website.googleMapOptions,
      };
    }

    return {
      mapOptions: {
        backgroundColor: '#F0F0F0',
        styles: [
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              { lightness: 50 },
              { visibility: 'simplified' },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
              { visibility: 'off' },
            ],
          },
          {
            featureType: 'poi',
            stylers: [
              { visibility: 'off' },
            ],
          },
        ],
      },
    };
  }
}

customElements.define('rentals-map', RentalsMap);
